import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { ref, onUnmounted, onMounted, computed } from 'vue'

const config = {
  apiKey: "AIzaSyCtkb76ZKEy43ilmcni6vkT5euHRkBxdIU",
  authDomain: "myfantasyroom-reklamationen.firebaseapp.com",
  projectId: "myfantasyroom-reklamationen",
  storageBucket: "myfantasyroom-reklamationen.firebasestorage.app",
  messagingSenderId: "497206671939",
  appId: "1:497206671939:web:db2fc85384a6f1fa0db2f6"
};

export const firebaseApp = initializeApp(config)
const analytics = getAnalytics(firebaseApp)

export const useAuthState = () => {
  const user = ref(null)
  const error = ref(null)

  const auth = getAuth()
  let unsubscribe
  onMounted(() => {
    unsubscribe = onAuthStateChanged(
      auth,
      (u) => (user.value = u),
      (e) => (error.value = e)
    )
  })
  onUnmounted(() => unsubscribe())

  const isAuthenticated = computed(() => useAuthState.value != null)

  return { user, error, isAuthenticated }
}

export const getUserState = () =>
  new Promise((resolve, reject) => onAuthStateChanged(getAuth(), resolve, reject))
